module.exports = __webpack_public_path__ + "static/media/depositSlide3.4eb0c9fd.svg";